import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type { IReportColumnPayload } from '../types';
import {
  REMOVE_REPORT_COLUMN_API_URL,
  REMOVE_REPORT_COLUMN_MUTATION,
  ROLES_PERMISSIONS,
} from '../constants';

export default function useRemoveReportColumnMutation(): IContextMutationResult<
  void,
  Error,
  IReportColumnPayload
> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IReportColumnPayload>({
    mutationKey: [REMOVE_REPORT_COLUMN_MUTATION],
    mutationFn: (payload) => fetchPost<void>(
      REMOVE_REPORT_COLUMN_API_URL,
      { report_field: payload },
      { permission: ROLES_PERMISSIONS.REPORT_FIELDS },
    ),
  });
}
